import React from 'react'
import { useTranslation } from 'react-i18next'
import { HelpHint } from 'is24-corecss'

export interface PictureCountStatusMessageProps {
  pictureCount: number
}

//TODO aantkowiak: this component will be replaced by Cosma Notification component when available
export const PictureCountStatusMessage: React.FC<PictureCountStatusMessageProps> = ({ pictureCount }) => {
  const { t } = useTranslation()

  if (pictureCount === 0) {
    return null
  }

  const message =
    pictureCount <= 2
      ? t('wizard.screen.multimedia.webview.modal.pictureCountInfo.lessEqualTwo')
      : t('wizard.screen.multimedia.webview.modal.pictureCountInfo.moreThanTwo')

  return (
    <HelpHint data-testid='status-message-close-button' message={message} hasInfoIcon />
    // <Notification key={`flat-info`} message={messages} type={'info'} variant="flat" />
    // https://scout24.github.io/frontend-core/?path=/story/cosma-components-react-notification--flat-variants
  )
}
